import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LayoutShell from "./layout/LayoutShell";
import ProtectedRoute from "./Routes/ProtectedRoutes";
import Login from "./Authentication/Login";
import AuthCallback from "./Authentication/Msal_Authentication/AuthCallback";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />

        {/* 🔥 THIS WAS MISSING */}
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Protected Routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <LayoutShell />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
